var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVertBlueSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.3 320.2",
    style: {
      enableBackground: "new 0 0 47.3 320.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00B1D9;}\n\t.st1{fill:#9CB6B7;}\n\t.st2{fill:#003E4C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000016792960537037345330000005639569681634217088_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Dotted-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    className: "st0",
    width: 8.6,
    height: 266.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.8,266.5h-8.5v-12h8.5V266.5z M29.8,242.5h-8.5v-12h8.5V242.5z M29.8,218.5h-8.5v-12h8.5V218.5z  M29.8,194.4h-8.5v-12h8.5V194.4z M29.8,170.4h-8.5v-12h8.5V170.4z M29.8,146.4h-8.5v-12h8.5V146.4z M29.8,122.4h-8.5v-12h8.5 V122.4z M29.8,98.4h-8.5v-12h8.5V98.4z M29.8,74.4h-8.5v-12h8.5V74.4z M29.8,50.4h-8.5v-12h8.5V50.4z M29.8,26.4h-8.5v-12h8.5 V26.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertBlueSimple);
export default __webpack_public_path__ + "static/media/vertBlueSimple.45376ddf64a9223a72aa2440740f45e7.svg";
export { ForwardRef as ReactComponent };